import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { concat } from 'ramda';
import { useReactToPrint } from 'react-to-print';
import qs from 'qs';

import { Paper, Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import MTable from '../../../components/MTable';
import TableMobile from '../../../components/TableMobile';
import ModalDrawerSwitcher from '../../../components/ModalDrawerSwitcher';
import Filter from '../../../components/Filter/components';
import FilterMobile from '../../../components/FilterMobile/components';
import Select from '../../../components/Select';
import Button from '../../../components/Button';
import Invoice from '../../../components/Invoice';
import InvoicePos from '../../../components/InvoicePos';
import ClientsExport from './Export';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faPen, faFileAlt, faFileInvoiceDollar, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import { persistQueryParamsSearch, clearSearch } from 'components/Filter/store/actions';
import { loadFilters } from 'components/Filter/store/thunk';
import { selectClient, setClientsFilter } from '../store/actions';
import { requestLoadClients, requestClientExportation } from '../store/thunk';
import { clearBasicInfo, setClientId, setIsEdit } from '../../ClientRegistration/components/steps/BasicInfo/store/actions';
import { setEstablishmentId } from '../../BusinessInfo/store/actions';
import { setInvoiceId } from '../../ClientInvoices/store/actions';

import { formatFilters, formatterClients } from '../../../helpers/formatters';
import { convertList } from '../../../helpers/converters';
import { inputs } from './resources';

import { useStyles } from './styles';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';
import useDidMount from 'helpers/hooks/useDidMount';

import { SITE_RESTRICTIONS } from '../../../helpers/restrictions';

const DownloadIcon = require('../../../assets/img/icon_download.svg');
const PencilIcon = require('../../../assets/img/icon_pencil.svg');
const iconAvulso = require('../../../assets/img/icon_avulso.svg');
const iconMensalista = require('../../../assets/img/icon_mensalista.svg');
const iconPosPagoEstacionamento = require('../../../assets/img/icon_pos_pago_estacionamento.svg');
const iconPosPagoEstetica = require('../../../assets/img/icon_pos_pago_estetica.svg');

const headers = [
  { title: 'Nome', field: 'name', sortable: false },
  { title: 'Contatos', field: 'contacts', sortable: false },
  { title: 'Situação da fatura', field: 'clientInvoiceSituation', sortable: false },
  { title: 'Data de vencimento', field: 'dueDateTime', sortable: false },
  { title: 'Observação', field: 'comments', sortable: false }
];

const exportHeaders = [
  { label: 'Nome', id: 'name' },
  { label: 'E-mail', id: 'email' },
  { label: 'Telefone', id: 'phones' },
  { label: 'Situação da fatura', id: 'clientInvoiceSituation' },
  { label: 'Data de vencimento', id: 'dueDateTime' },
  { label: 'Valor da fatura', id: 'invoiceAmount' },
  { label: 'Veículos', id: 'vehicles' },
  { label: 'Vagas', id: 'vacancies' },
  { label: 'Observação', id: 'comments' }
];

export default function ClientList() {
  const dispatch = useDispatch();

  const history = useHistory();
  const { search } = useLocation();
  const locationParams = new URLSearchParams(search);

  const isNewClient = locationParams.get('newClient');

  const classes = useStyles();

  const didComponentMount = useDidMount();

  const { width } = useWindowDimensions();
  const isMobile = width < 962;
  const tableEditActionWidth = width < 768 ? 100 : 80;

  const [exportData, setExportData] = useState({
    content: [],
    total: 0
  });

  const contentRef = useRef(null);
  const reactToPrint = useReactToPrint({ contentRef, documentTitle: 'clientes', preserveAfterPrint: true });

  const { userId, submit: { isAdminUser } } = useSelector(state => state.profile);
  const { establishmentId, establishmentTypes } = useSelector(state => state.businessInfo);
  const { clients: fetchClients, total, isLoading, clientsPage: clientsPageFilter, clientsQp: clientsQpFilter } = useSelector(state => state.clientList);
  const { selects, qp, isExporting } = useSelector(state => state.filters);
  const userRestrictions = useSelector(state => state.profile.userRestrictions);
  const situationEstablishments = useSelector(state => state.login.situation.establishments);

  const isUserAdmin = +isAdminUser == 1;

  const [isClientSelectionDrawerOpen, setIsClientSelectionDrawerOpen] = useState(false);
  const [clientSelectionOptions, setClientSelectionOptions] = useState([]);
  const [selectedClientTypeId, setSelectedClientTypeId] = useState(null);
  const [selectedInvoiceEstablishmentId, setSelectedInvoiceEstablishmentId] = useState(null);

  const [isOpenInvoice, setIsOpenInvoice] = useState(false);
  const [isOpenInvoicePos, setIsOpenInvoicePos] = useState(false);

  const [clientsPage, setClientsPage] = useState(1);
  const clientsPageSize = 10;
  const clientsPageCount = Math.ceil(total / clientsPageSize);

  const selectedClientType = clientSelectionOptions?.find(client => +client.value == +selectedClientTypeId) || {};

  const [defaultEstablishmentTypes, setDefaultEstablishmentTypes] = useState(establishmentTypes?.map(type => +type) || []);

  const isCarWashOnly = defaultEstablishmentTypes?.length == 1 && +defaultEstablishmentTypes[0] == 2;
  const isStoreOnly = defaultEstablishmentTypes?.length == 1 && +defaultEstablishmentTypes[0] == 3;
  const isCarWashAndNotParking = defaultEstablishmentTypes?.includes(2) && !defaultEstablishmentTypes?.includes(1);
  const isCarWashAndParking = defaultEstablishmentTypes?.includes(1) && defaultEstablishmentTypes?.includes(2);
  const isCarWash = defaultEstablishmentTypes?.includes(2);
  const isParking = defaultEstablishmentTypes?.includes(1);

  useEffect(() => {
    setIsOpenInvoice(false);
    setIsOpenInvoicePos(false);
  }, []);

  useEffect(() => {
    if(!isUserAdmin) {
      setDefaultEstablishmentTypes(establishmentTypes?.map(type => +type));
    }

    if(isUserAdmin) {
      const establishment = situationEstablishments?.find(establishment => +establishment.establishmentId == +establishmentId) || {};
      setDefaultEstablishmentTypes(establishment?.establishmentTypes?.map(type => +type));
    }
  }, [establishmentTypes, establishmentId]);

  useEffect(() => {
    dispatch(setIsEdit(false));

    const clientAvulso = {
      label: 'Cliente avulso',
      value: 1,
      icon: iconAvulso,
      description: 'Cliente que pode receber restrições ou automações. Não possuem faturas.',
      details: 'Aplica-se para Condôminios, amigos com desconto específico, clientes com cobrança automática.'
    }

    const clientMensalista = {
      label: 'Mensalista',
      value: 2,
      icon: iconMensalista,
      description: 'Cliente mensalista, mas também pode criar cobranças quinzenais ou semanais.',
      details: 'Aplica-se para clientes que pagam um valor fixo todo mês, mensalistas. Ou clientes que pagam um valor fixo a cada quinzena ou semana.'
    }

    const clientPosPago = {
      label: 'Cliente pós pago de estacionamento',
      value: 4,
      icon: iconPosPagoEstacionamento,
      description: 'Clientes com faturas acumulativas e com fechamento de fatura antes do pagamento da fatura.',
      details: 'Aplica-se para clientes como empresas ou pessoas, que pagam após uso dos serviços e acumulam um saldo em uma fatura. Após o pagamento das faturas, as OS mudam o estado financeiro de "A Faturar" para "Faturada". E o dinheiro entra na empresa apenas após o pagamento da fatura.'
    }

    const clientPosPagoDeEstetica = {
      label: 'Cliente pós pago de estética',
      value: 5,
      icon: iconPosPagoEstetica,
      description: 'Clientes com faturas acumulativas e com fechamento de fatura antes do pagamento da fatura.',
      details: 'Aplica-se para clientes como empresas ou pessoas, que pagam após uso dos serviços e acumulam um saldo em uma fatura. Após o pagamento das faturas, as OS mudam o estado financeiro de "A Faturar" para "Faturada". E o dinheiro entra na empresa apenas após o pagamento da fatura.'
    }

    if(isCarWashOnly) {
      const initialOptions = [
        clientAvulso,
        {
          label: 'Cliente pós pago',
          value: 5,
          icon: iconPosPagoEstetica,
          description: 'Clientes com faturas acumulativas e com fechamento de fatura antes do pagamento da fatura.',
          details: 'Aplica-se para clientes como empresas ou pessoas, que pagam após uso dos serviços e acumulam um saldo em uma fatura. Após o pagamento das faturas, as OS mudam o estado financeiro de "A Faturar" para "Faturada". E o dinheiro entra na empresa apenas após o pagamento da fatura.'
        }
      ];

      return setClientSelectionOptions(initialOptions);
    }

    if(isStoreOnly) {
      const initialOptions = [
        clientAvulso
      ];

      return setClientSelectionOptions(initialOptions);
    }

    if(isCarWashAndParking) {
      const initialOptions = [
        clientAvulso,
        clientMensalista,
        clientPosPago,
        clientPosPagoDeEstetica
      ];

      return setClientSelectionOptions(initialOptions);
    }

    if(isCarWashAndNotParking) {
      const initialOptions = [
        clientAvulso,
        clientPosPagoDeEstetica
      ];

      return setClientSelectionOptions(initialOptions);
    }

    if(establishmentTypes?.includes(1)) {
      const initialOptions = [
        clientAvulso,
        clientMensalista,
        clientPosPago
      ];

      return setClientSelectionOptions(initialOptions);
    }

    const initialOptions = [
      clientAvulso,
      clientMensalista,
      clientPosPago,
      clientPosPagoDeEstetica
    ];

    setClientSelectionOptions(initialOptions);
  }, [userId, establishmentId]);

  const clientTypeFilterValue = () => {
    const client = {
      empty: {
        label: '--',
        value: ''
      },
      avulso: {
        label: 'Cliente avulso',
        value: 1
      },
      mensalista: {
        label: 'Mensalista',
        value: 2
      },
      posPagoEstacionamento: {
        label: 'Cliente pós pago de estacionamento',
        value: 4
      },
      posPagoEstetica: {
        label: 'Cliente pós pago de estética',
        value: 5
      }
    }

    if(isCarWashOnly) {
      return [
        client.empty,
        client.avulso,
        client.posPagoEstetica
      ];
    }

    if(isStoreOnly) {
      return [
        client.empty,
        client.avulso
      ];
    }

    if(isCarWashAndParking) {
      return [
        client.empty,
        client.avulso,
        client.mensalista,
        client.posPagoEstacionamento,
        client.posPagoEstetica
      ];
    }

    return [
      client.empty,
      client.avulso,
      client.mensalista,
      ...(isParking ? [client.posPagoEstacionamento] : []),
      ...(isCarWash ? [client.posPagoEstetica] : [])
    ];
  }

  const filters = concat(formatFilters(['clientType', 'clientInvoiceSituation', 'status', 'card'], selects), inputs)?.map(filter => {
    return filter?.id == 'clientType' ? {
      ...filter,
      options: clientTypeFilterValue()
    }
    : filter
  });

  const clients = convertList(['clientInvoiceSituation'], filters, fetchClients);

  const handleLoadClients = ({ page, qp }) => {
    const queryParams = qs.parse(qp);

    if(!queryParams['clientType']) {
      delete queryParams['clientType'];
    }

    return dispatch(requestLoadClients({ userId, establishmentId, page, qp: `&${qs.stringify(queryParams)}` }));
  }

  const handleClientExportation = (userId, establishmentId, qp) => {
    return dispatch(requestClientExportation(userId, establishmentId, qp))
      .then(({ content, total }) => setExportData({ content, total }))
      .catch(() => setExportData({ content: [], total: 0 }));
  }

  useEffect(() => {
    dispatch(persistQueryParamsSearch(''));
  }, []);

  useEffect(() => {
    dispatch(loadFilters(userId, establishmentId));
    dispatch(clearSearch());

    if(+clientsPageFilter > 1 || !!clientsQpFilter) {
      dispatch(persistQueryParamsSearch(clientsQpFilter));
      setClientsPage(clientsPageFilter);
      handleLoadClients({ page: clientsPageFilter, qp: clientsQpFilter });

      dispatch(setClientsFilter({ page: 1, qp: '' }));
      return;
    }

    handleLoadClients({ page: 1, qp: '' });
  }, [establishmentId]);

  useEffect(() => {
    if(!didComponentMount) {
      handleLoadClients({ page: clientsPage, qp });
    }
  }, [clientsPage]);

  const getClientContact = item => {
    const { email, phones } = item || {};
    const phone = phones?.length > 0 ? phones[0] : '';

    const hasEmail = email != '--' && email != '' ;
    const hasPhone = phone != '--' && phone != '' && !!phone;

    if(hasEmail && !hasPhone) {
      return email;
    }

    if(!hasEmail && hasPhone) {
      return phone;
    }

    if(hasEmail && hasPhone) {
      return `${email} / ${phone}`;
    }

    return '--';
  }

  const handleGoToEdit = client => {
    const { clientTypeId, clientId, establishmentId } = client;

    dispatch(setIsEdit(true));
    dispatch(selectClient(clientTypeId));
    dispatch(setClientId(clientId));
    dispatch(setEstablishmentId({ establishmentId }));

    history.push({
      pathname: '/cadastro-de-cliente/informacoes-basicas/',
      state: {
        data: {
          userId,
          establishmentId,
          clientId,
          isEdit: true
        }
      }
    });
  }

  const handleGoToInvoices = async client => {
    const { clientId, establishmentId } = client;

    await dispatch(setClientsFilter({ page: clientsPage, qp }));
    await dispatch(setClientId(clientId));
    await dispatch(setEstablishmentId({ establishmentId }));
    await history.push('/faturas');
  }

  const handleGoToLastInvoice = async client => {
    const { clientId, establishmentId, invoiceDateTime } = client;

    if(!invoiceDateTime) {
      return toast.error('Nenhuma fatura encontrada.');
    }

    setSelectedInvoiceEstablishmentId(establishmentId);

    await dispatch(setClientId(clientId));
    await dispatch(setInvoiceId(invoiceDateTime));

    if(+client.clientTypeId == 2) {
      setIsOpenInvoice(true);
      return;
    }

    if(+client.clientTypeId == 4 || +client.clientTypeId == 5) {
      setIsOpenInvoicePos(true);
      return;
    }
  }

  const checkClientType = row => {
    const styles = { backgroundColor: 'none' };

    if(row) {
      const { clientTypeId } = row;

      if(clientTypeId === 1) {
        styles.backgroundColor = '#f8f9fa';
      }
    }

    return styles;
  }

  const verifyTypeClient = rowData => {
    if(rowData.clientTypeId === 5) {
      return false;
    }

    if(rowData.clientTypeId === 4) {
      return false;
    }

    if(rowData.clientTypeId === 2) {
      return false;
    }

    return true;
  }

  return(
    <>
      <div style={{ display: 'none' }}>
        <ClientsExport
          ref={contentRef}
          data={exportData}
        />
      </div>
      {isMobile && (
        <Grid container style={{ marginBottom: 10 }}>
          <Grid item xs={12}>
            <Button
              type="button"
              color="success"
              startIcon={
                <FontAwesomeIcon
                  icon={faPlusCircle}
                  color="#FFFFFF"
                  size="xs"
                />
              }
              onClick={() => setIsClientSelectionDrawerOpen(true)}
            >
              Cadastrar Cliente
            </Button>
          </Grid>
        </Grid>
      )}
      <Paper>
        {(isClientSelectionDrawerOpen || isNewClient) && (
          <ModalDrawerSwitcher
            id='client-selection-drawer'
            title='Adicionar cliente'
            open={isClientSelectionDrawerOpen || isNewClient}
            onClose={() => {
              setIsClientSelectionDrawerOpen(false);
              history.push(window.location.pathname);
            }}
          >
            <Grid container>
              <Grid xs={12}>
                <Typography color='primary' style={{ borderBottom: '1px solid #E4E7EA' }}>
                  <b>Selecione o tipo de cliente</b>
                </Typography>
              </Grid>
              <Grid xs={12}>
                <Select
                  id='client-selection-modal-options'
                  options={clientSelectionOptions}
                  value={selectedClientTypeId}
                  onChange={event => setSelectedClientTypeId(event.target.value)}
                />
              </Grid>
              {!!selectedClientTypeId && (
                <Grid xs={12} style={{
                  backgroundColor: '#FCFCFC',
                  border: '1px solid #D7D7D7',
                  borderRadius: 5,
                  padding: 10,
                  marginTop: 10,
                  marginBottom: 10
                }}>
                  <Grid container>
                    <Grid xs={12} style={{ borderBottom: '1px solid #E4E7EA', paddingBottom: 10, marginBottom: 10 }}>
                      <Grid container>
                        <Grid xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <img src={selectedClientType?.icon} />
                        </Grid>
                        <Grid xs={10}>
                          <Typography color='textSecondary'>
                            <b>{selectedClientType?.label}</b>
                          </Typography>
                          <Typography>{selectedClientType?.description}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid xs={12} style={{ paddingBottom: 10, marginBottom: 10 }}>
                      <Grid container>
                        <Grid xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5 }}>
                          <FontAwesomeIcon
                            icon={faExclamationCircle}
                            color="#757575"
                            size="2x"
                          />
                        </Grid>
                        <Grid xs={10} style={{ padding: '10px 0 10px 0' }}>
                          <Typography variant='body2'>{selectedClientType?.details}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {!selectedClientTypeId && (
                <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 10 }}>
                  <Button
                    color='tertiary'
                    variant='outlined'
                    onClick={() => {
                      setSelectedClientTypeId(null);
                      setIsClientSelectionDrawerOpen(false);
                      history.push(window.location.pathname);
                    }}
                  >
                    Fechar
                  </Button>
                </Grid>
              )}
              {!!selectedClientTypeId && (
                <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 10 }}>
                  <Button
                    color='tertiary'
                    variant='outlined'
                    onClick={() => setSelectedClientTypeId(null)}
                  >
                    Voltar
                  </Button>
                  <Button
                    color='success'
                    onClick={() => {
                      dispatch(clearBasicInfo());
                      dispatch(selectClient(parseInt(selectedClientTypeId, 10)));
                      return history.push('/cadastro-de-cliente/informacoes-basicas/');
                    }}
                  >
                    Cadastrar
                  </Button>
                </Grid>
              )}
            </Grid>
          </ModalDrawerSwitcher>
        )}
        {isMobile ? (
          <FilterMobile
            filter
            hasSearchTerm
            filters={filters}
            handlePageRequest={({ page, qp }) => {
              setClientsPage(1);
              handleLoadClients({ page, qp });
            }}
            formatComponentData={formatterClients}
            exportType="clients"
            fileName="clientes"
            exportHeaders={establishmentId ? exportHeaders : [{ label: 'Estabelecimento', id: 'establishmentName' }, ...exportHeaders]}
            htmlExport
            htmlExportIcon={
              <img
                src={DownloadIcon}
                height={18}
                width={18}
              />
            }
            htmlExportFunction={() => {
              handleClientExportation(userId, establishmentId, qp, false)
                .then(() => reactToPrint());
            }}
            htmlExportCsvFunction={() => {
              return dispatch(requestClientExportation(userId, establishmentId, qp, true));
            }}
          />
        ) : (
          <Filter
            filter
            hasSearchTerm
            filters={filters}
            handlePageRequest={({ page, qp }) => {
              setClientsPage(1);
              handleLoadClients({ page, qp });
            }}
            formatComponentData={formatterClients}
            exportType="clients"
            fileName="clientes"
            exportHeaders={establishmentId ? exportHeaders : [{ label: 'Estabelecimento', id: 'establishmentName' }, ...exportHeaders]}
            htmlExport
            htmlExportFunction={() => {
              handleClientExportation(userId, establishmentId, qp, false)
                .then(() => reactToPrint());
            }}
            htmlExportCsvFunction={() => {
              return dispatch(requestClientExportation(userId, establishmentId, qp, true));
            }}
            actionButton={
              <Button
                type="button"
                color="primary"
                startIcon={
                  <FontAwesomeIcon
                    icon={faPlusCircle}
                    color="#FFFFFF"
                    size="xs"
                  />
                }
                onClick={() => setIsClientSelectionDrawerOpen(true)}
              >
                Adicionar Cliente
              </Button>
            }
          />
        )}
        <div className={classes.table}>
          {isMobile && (
            <TableMobile
              loading={isLoading || isExporting}
              data={clients?.map(item => {
                return {
                  ...item,
                  ...checkClientType(item),
                  name: {
                    index: 1,
                    label: 'Nome',
                    value: <Typography color='textSecondary' variant='subtitle2'>{item?.name}</Typography>
                  },
                  contacts: {
                    index: 2,
                    label: 'Contatos',
                    value: <Typography color='textSecondary' variant='subtitle2'>{getClientContact(item)}</Typography>
                  },
                  clientInvoiceSituation: {
                    index: 3,
                    label: 'Situação da fatura',
                    value: <Typography color='textSecondary' variant='subtitle2'>{item?.clientInvoiceSituation}</Typography>
                  },
                  dueDateTime: {
                    index: 4,
                    label: 'Data de vencimento',
                    value: <Typography color='textSecondary' variant='subtitle2'>{item?.dueDateTime}</Typography>
                  }
                }
              })}
              actions={[
                {
                  action: rowData => !verifyTypeClient(rowData) && (
                    <Tooltip placement='top' title='Fatura pendente' enterTouchDelay={0}>
                      <IconButton onClick={() => handleGoToLastInvoice(rowData)}>
                        <FontAwesomeIcon
                          icon={faFileInvoiceDollar}
                          color="#022A5C"
                          size="xs"
                        />
                      </IconButton>
                    </Tooltip>
                  )
                },
                {
                  action: rowData => !verifyTypeClient(rowData) && (
                    <Tooltip placement='top' title='Lista de faturas' enterTouchDelay={0}>
                      <IconButton onClick={() => handleGoToInvoices(rowData)}>
                        <FontAwesomeIcon
                          icon={faFileAlt}
                          color="#022A5C"
                          size="xs"
                        />
                      </IconButton>
                    </Tooltip>
                  )
                },
                {
                  action: rowData => !userRestrictions?.includes(SITE_RESTRICTIONS.EDIT_CLIENT) && (
                    <Tooltip placement='top' title='Editar cliente' enterTouchDelay={0}>
                      <IconButton onClick={() => handleGoToEdit(rowData)}>
                        <img src={PencilIcon} />
                      </IconButton>
                    </Tooltip>
                  )
                }
              ]}
            />
          )}
          {!isMobile && (
            <MTable
              loading={isLoading || isExporting}
              headers={headers}
              data={clients?.map(item => {
                return {
                  ...item,
                  contacts: getClientContact(item)
                }
              })}
              actions={[
                rowData => ({
                  icon: () => (
                    <FontAwesomeIcon
                      icon={faFileInvoiceDollar}
                      color="#022A5C"
                      size="xs"
                    />
                  ),
                  tooltip: 'Fatura pendente',
                  onClick: (event, rowData) => handleGoToLastInvoice(rowData),
                  hidden: verifyTypeClient(rowData)
                }),
                rowData => ({
                  icon: () => (
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      color="#022A5C"
                      size="xs"
                    />
                  ),
                  tooltip: 'Lista de faturas',
                  onClick: (event, rowData) => handleGoToInvoices(rowData),
                  hidden: verifyTypeClient(rowData)
                }),
                !userRestrictions?.includes(SITE_RESTRICTIONS.EDIT_CLIENT) && {
                  icon: () => (
                    <FontAwesomeIcon
                      icon={faPen}
                      color="#022A5C"
                      size="xs"
                    />
                  ),
                  tooltip: 'Editar cliente',
                  onClick: (event, rowData) => handleGoToEdit(rowData)
                }
              ]}
              actionColumnWidth={tableEditActionWidth}
              rowStyle={checkClientType}
            />
          )}
        </div>
        <Grid
          container
          xs={12}
          style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}
        >
          <Pagination
            color="primary"
            variant="outlined"
            shape="rounded"
            count={clientsPageCount}
            page={clientsPage}
            onChange={(_, page) => setClientsPage(page)}
          />
        </Grid>
        {isOpenInvoice && (
          <Invoice
            isOpen={isOpenInvoice}
            setIsOpenInvoice={setIsOpenInvoice}
            establishmentId={selectedInvoiceEstablishmentId}
            clientsPage={clientsPage}
            pageOrigin="clients"
          />
        )}
        {isOpenInvoicePos && (
          <InvoicePos
            isOpen={isOpenInvoicePos}
            setIsOpenInvoicePos={setIsOpenInvoicePos}
            establishmentId={selectedInvoiceEstablishmentId}
            clientsPage={clientsPage}
            pageOrigin="clients"
          />
        )}
      </Paper>
    </>
  );
}